import React from 'react';
import { connect } from 'react-redux';
import actions from 'actions';
import constants from 'constants';

const {
  hideModal,
  adminDeleteWebinarSaga,
  adminDeleteUserSaga,
  adminDeleteSponsorSaga
} = actions;

const {
  MODAL_DELETE_CONFIRMATION_TYPE
} = constants;

const ConfirmationModal = ({
  adminDeleteWebinarsSaga,
  contentProps,
  adminDeleteUsersSaga,
  adminDeleteSponsorsSaga,
  hideModal
}) => {
  const { type, ids } = (contentProps || {});
  const deleteAcion = () => {
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.webinar) {
      adminDeleteWebinarsSaga(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.user) {
      adminDeleteUsersSaga(ids);
    }
    if (type === MODAL_DELETE_CONFIRMATION_TYPE.sponsor) {
      adminDeleteSponsorsSaga(ids);
    }
    hideModal();
  }
  return (
    <div className="action-confirmation">
      <h5 className="title">
        Are you sure you want to delete these
        {type === MODAL_DELETE_CONFIRMATION_TYPE.webinar && ' webinars?'}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.user && ' users?'}
        {type === MODAL_DELETE_CONFIRMATION_TYPE.sponsor && ' sponsors?'}
      </h5>
      <div className="actions">
        <button className="delete-action" onClick={deleteAcion}>
          Yes, Delete
        </button>
        <button className="cancel-action" onClick={hideModal}>
          Cancel
        </button>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    contentProps: state.modal.modalContentProps
  }
}

function mapDispatchToProps(dispatch) {
  return {
    adminDeleteWebinarsSaga: (ids) => dispatch(adminDeleteWebinarSaga(ids)),
    adminDeleteUsersSaga: (ids) => dispatch(adminDeleteUserSaga(ids)),
    adminDeleteSponsorsSaga: (ids) => dispatch(adminDeleteSponsorSaga(ids)),
    hideModal: () => dispatch(hideModal())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ConfirmationModal
);



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/ConfirmationModal/index.js
 **/